module.exports = __webpack_public_path__ + "files/30da022fbcdbd6504e58e89c5bfdbf5c.png";